import React, { useState, useRef } from 'react';
import { ChevronDown, Lock } from 'lucide-react';
import DropdownMenu from './DropdownMenu';
import './Dropdown.css';

export default function Dropdown({
  label,
  value,
  onChange,
  options, // [{ value: 'ja', label: 'Japanese', icon: '🇯🇵', description: '...', leftIcon: <Icon />, pinned: false }]
  placeholder = 'Select...',
  disabled = false,
  showDescription = false,
  maxHeight = null, // optional max height override for dropdown menu
  // Action handlers (optional)
  onPin = null,
  onDelete = null,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);

  const selectedOption = options.find(opt => opt.value === value);

  const handleToggle = () => {
    if (disabled) return;
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className={`dropdown-container ${disabled ? 'disabled' : ''}`}>
        {label && <label className="dropdown-label">{label}</label>}

        <button
          ref={triggerRef}
          type="button"
          className={`dropdown-trigger ${isOpen ? 'open' : ''} ${disabled ? 'disabled' : ''}`}
          onClick={handleToggle}
          disabled={disabled}
        >
          <span className="dropdown-value">
            {selectedOption ? (
              <>
                {selectedOption.icon && <span className="dropdown-icon">{selectedOption.icon}</span>}
                <span>{selectedOption.label}</span>
              </>
            ) : (
              <span className="dropdown-placeholder">{placeholder}</span>
            )}
          </span>
          {disabled ? (
            <Lock size={16} className="dropdown-lock" />
          ) : (
            <ChevronDown size={20} className={`dropdown-chevron ${isOpen ? 'open' : ''}`} />
          )}
        </button>
      </div>

      {/* Use DropdownMenu component */}
      <DropdownMenu
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        options={options}
        value={value}
        onChange={onChange}
        triggerRef={triggerRef}
        showDescription={showDescription}
        showCheck={true}
        maxHeight={maxHeight}
        onPin={onPin}
        onDelete={onDelete}
      />
    </>
  );
}

